import { connect } from 'react-redux';
import actions from '../reduxStore/action';
import { instance } from './axios-config';
import { logError } from './errorLogger';

const RefreshTokens = (props) => {
  const { toggleSnackBar } = props;
  let isAlreadyFetchingAccessToken = false;
  let subscribers = [];

  const onAccessTokenFetched = (accessToken) => {
    subscribers = subscribers.filter((callback) => callback(accessToken));
  };

  const addSubscriber = (callback) => {
    subscribers.push(callback);
  };

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const { config, response: { status } = 'cors' } = error;
      const originalRequest = config;

      if (status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true;
          props.refresh().then(() => {
            isAlreadyFetchingAccessToken = false;
            onAccessTokenFetched(props.auth.accessToken);
          });
        }

        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber((accessToken) => {
            originalRequest.headers.Authorization = `Bearer ${accessToken}`;
            resolve(instance(originalRequest));
          });
        });
        return retryOriginalRequest;
      }
      if (status === 403) {
        // Router.back();
        // actions.logout();
        return Promise.reject();
      }
      logError(error.message, 'utils/refreshTokens.js');

      toggleSnackBar(error);

      return Promise.resolve(originalRequest);
    },
  );
  return null;
};
const mapStateToProps = (state) => state;
export default connect(mapStateToProps, actions)(RefreshTokens);
